import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Input, Label, Row } from 'reactstrap';
import InputField from '../../../components/layout/InputField';
import { CANDIDATE_ONLY, countries, COUNTRY_STATES_PROVINCE } from '../../../utils/constant';
import '../../company/company.scss';
import Select from 'react-select';
import { Controller } from 'react-hook-form';
import { customSelectStyleNew } from '../../../components/styled/customSelect';
import { AppContext } from '../../../context';

const AddressInfo = (params: any) => {
  const {
    register,
    errors,
    watch,
    companyId,
    headQatar = true,
    givenStates,
    isEdit,
    defaultChecked = false,
    setValue,
    placementAddressInfo = false,
    addressObj,
    reset,
    control,
    companyAddress = false,
    addressId = '',
    ...props
  } = params || {}
  const { theme } = useContext(AppContext);
  const { countryCode } = watch() || {};
  const { pathname } = useLocation();
  const [countriesOption] = useState(() =>
    (pathname.includes('candidate') || props?.fromCandidate) ? [...countries, ...CANDIDATE_ONLY] : [...countries]
  );

  useEffect(() => {
    if (!placementAddressInfo) {
      // setValue('countryCode', 'US');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!['US', 'CA', 'MX', null, undefined, ''].includes(countryCode)) {
      setValue('stateCode', undefined);
    }
  }, [countryCode, setValue]);
  return (
    <div>
      <div>
        {companyId && !addressId ? (
          <h5 className="m-0">New Address</h5>
        ) : companyId && addressId ? <h5 className="m-0">Update Address</h5> : (
          <div>
            {headQatar && (
              <Label className="m-0">Head Quarter/Primary address</Label>
            )}
          </div>
        )}
      </div>
      <div className="user-basic-form">
        <Row>
          {
            countryCode !== 'MX' ? (
              <>
                {companyAddress &&
                  <Col xl="3" lg="6" xs="12">
                    <InputField
                      inputtype="text"
                      label="Division"
                      inputid="division"
                      placeholder="Division"
                      {...register('division')}
                      errMsg={errors?.division?.message as any}
                    />
                  </Col>
                }
                <Col xl="3" lg="6" xs="12">
                  <InputField
                    inputtype="text"
                    isRequired={!!companyId}
                    label="Street"
                    inputid="streetAddress"
                    placeholder="Street"
                    {...register('streetAddress', {
                      required: {
                        value: !!companyId,
                        message: 'Street address is required!',
                      },
                    })}
                    errMsg={errors?.streetAddress?.message as any}
                  />
                </Col>
              </>

            ) : (
              <>
                <Col xl="3" lg="6" xs="12">
                  <InputField
                    inputtype="text"
                    isRequired={!!companyId}
                    label="Address 1"
                    inputid="address1"
                    placeholder="Address 1"
                    {...register('address1', {
                      required: {
                        value: !!companyId,
                        message: 'Address 1 is required!',
                      },
                    })}
                    errMsg={errors?.address1?.message as any}
                  />
                </Col>
                <Col xl="3" lg="6" xs="12">
                  <InputField
                    inputtype="text"
                    isRequired={!!companyId}
                    label="Address 2"
                    inputid="address2"
                    placeholder="Address 2"
                    {...register('address2', {
                      required: {
                        value: !!companyId,
                        message: 'Address 2 is required!',
                      },
                    })}
                    errMsg={errors?.address2?.message as any}
                  />
                </Col>
              </>
            )
          }


          <Col xl={countryCode !== 'MX' ? "3" : "6"} lg="6" xs="12">
            <InputField
              inputtype="text"
              label="City"
              inputid="city"
              isRequired={true}
              placeholder="City"
              {...register('city', {
                required: {
                  value: true,
                  message: 'City is required!',
                },
              })}
              errMsg={errors?.city?.message as any}
            />
          </Col>

          <Col xl="4" lg="6" xs="12">
            <Controller
              name="stateCode"
              control={control}
              rules={{
                required: {
                  value: ['US', 'CA', 'MX', null, undefined, ''].includes(countryCode),
                  message: `${countryCode === 'CA' ? 'Province' : 'State'} is required!`,
                },
              }}
              render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
                <div className="form-group">
                  <label>{countryCode === 'CA' ? 'Province' : 'State'}</label>
                  <Select
                    {...ref}
                    instanceId="stateCode"
                    options={COUNTRY_STATES_PROVINCE(countryCode)}
                    isDisabled={!['US', 'MX', 'CA', null, undefined, ''].includes(countryCode)}
                    placeholder={`Please select any ${countryCode === 'CA' ? 'province' : 'state'}`}
                    value={COUNTRY_STATES_PROVINCE(countryCode)?.find(opt => opt.value === value) || null}
                    onChange={(val: any) => onChange(val?.value)}
                    styles={customSelectStyleNew(theme)}
                  />
                  {error && <span className="error-text">{error.message}</span>}
                </div>
              )}
            />
          </Col>
          <Col xl="2" lg="6" xs="12">
            <InputField
              inputtype="text"
              label="Zip"
              inputid="zipCode"
              placeholder="Zip code"
              {...register('zipCode', {
                required: {
                  value: false,
                  message: 'Zip code is required!',
                },
              })}
              errMsg={errors?.zipCode?.message as any}
            />
          </Col>
          <Col xl="6" lg="6" xs="12">
            <Controller
              name="countryCode"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: 'Country is required!',
                },
              }}
              render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
                <div className="form-group">
                  <label>
                    Country <span className="text-danger">*</span>
                  </label>
                  <Select
                    {...ref}
                    instanceId="countryCode"
                    placeholder="Please select any country"
                    options={countriesOption}
                    value={countriesOption?.find((opt) => opt.value === value) || null}
                    onChange={(val: any) => {
                      onChange(val?.value);
                    }}
                    styles={customSelectStyleNew(theme)}
                  />
                  {error && <span className="error">{error.message}</span>}
                </div>
              )}
            />
          </Col>

          {((defaultChecked || companyId) && !addressId) && (
            <Col xl="3" lg="6" xs="12">
              <div className="d-flex-field address-is-primary">
                <label>&nbsp;</label>
                <Label className="radio-container">
                  is Primary
                  <Controller
                    name="isPrimary"
                    control={control}
                    defaultValue={defaultChecked}
                    render={({ field }) => (
                      <Input
                        type="checkbox"
                        checked={field.value === true}
                        onChange={(e) => field.onChange(e.target.checked)}
                        onBlur={field.onBlur}
                        innerRef={field.ref}
                      />
                    )}
                  />
                  <span className="checkmark"></span>
                </Label>
              </div>
            </Col>
          )}
        </Row>
        <Row></Row>
      </div>
    </div>
  );
};

export default AddressInfo;